<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES Y RAMAS EN ORILLAS -->
    <div class="deco-wrapper deco-lt" ref="decoLtRef">
      <img src="@/assets/rama.png" class="rama-img render-gpu" alt="Rama" />
      <img src="@/assets/monio.png" class="flor-img render-gpu" alt="Moño" />
    </div>

    <div class="deco-wrapper deco-rb" ref="decoRbRef">
      <img src="@/assets/rama.png" class="rama-img render-gpu" alt="Rama" />
      <img src="@/assets/monio.png" class="flor-img render-gpu" alt="Moño" />
    </div>

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item render-gpu"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
          loading="eager"
        />
      </div>
    </div>

    <!-- MODAL -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
        alt="Imagen ampliada"
      />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [
      require('@/assets/5_web.webp'),

                  require('@/assets/7_web.webp'),



    ]

    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])
    const decoLtRef = ref(null)
    const decoRbRef = ref(null)

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    let observer = null

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()

      // Forzar aceleración por hardware estricta en GSAP
      gsap.config({ force3D: true })

      // IntersectionObserver liviano (reacción inmediata al tocar 10% de pantalla)
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out', force3D: true } })

          // 1. Revelado instantáneo de la foto (en 0.25s en lugar de esperar la timeline)
          tl.to(bgRef.value, { autoAlpha: 1, duration: 0.3 })
            .to(collageItems.value, {
              autoAlpha: 1,
              y: 0,
              scale: 1,
              duration: 0.45,
              stagger: 0.08
            }, '-=0.2')

          // 2. Despliegue botánico estilo "floración" (Ramas + Moños)
          if (decoLtRef.value) {
            tl.fromTo(decoLtRef.value, 
              { autoAlpha: 0, scale: 0.85, rotate: -8 },
              { autoAlpha: 1, scale: 1, rotate: 0, duration: 0.5, ease: 'back.out(1.2)' },
              '-=0.3'
            )
          }

          if (decoRbRef.value) {
            tl.fromTo(decoRbRef.value, 
              { autoAlpha: 0, scale: 0.85, rotate: 8 },
              { autoAlpha: 1, scale: 1, rotate: 0, duration: 0.5, ease: 'back.out(1.2)' },
              '-=0.4'
            )
          }

          // Desconectar el observador para liberar memoria inmediatamente
          if (rootRef.value) observer.unobserve(rootRef.value)
        })
      }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' })

      if (rootRef.value) observer.observe(rootRef.value)
    })

    onUnmounted(() => {
      if (observer) observer.disconnect()
    })

    return {
      images, rootRef, bgRef, collageItems, decoLtRef, decoRbRef,
      currentIndex, isImageEnlarged, enlargeImage, closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 55vh;
  margin-bottom: -20px;
  overflow: visible;
}

.bg-rosa {
  position: absolute;
  inset: 0;
  background: #f0c9d3;
  z-index: 0;
  opacity: 0;
}

/* 🌸 DECORACIONES */
.deco-wrapper {
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: 0;
}

.flor-img {
  width: 110px;
  max-width: 32vw;
  position: relative;
  z-index: 12;
  height: auto;
  object-fit: contain;
}

.rama-img {
  position: absolute;
  width: 230px !important;
  max-width: 75vw;
  height: auto;
  object-fit: contain;
  z-index: 11;
  margin-top: 90px;
  filter: brightness(1.05);
}

.deco-lt { 
  top: 1vh; 
  left: -10px; 
}

.deco-rb { 
  bottom: 4vh; 
  right: -10px; 
}

.deco-rb .rama-img {
  margin-top: 0px;
  transform: rotate(180deg);
}

/* GRID Y FOTO CON CARGA RÁPIDA */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding: 4vh 0;
}

.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-bottom: 2vh;
}

.collage-image {
  width: 88%;
  max-width: 480px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.enlarged-image {
  max-width: 90%;
  max-height: 85%;
  border-radius: 12px;
  box-shadow: 0 0 25px rgba(0,0,0,0.5);
}

.rasgado-inferior {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: #f0c9d3;
  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
  z-index: 1;
}

/* Clases de Aceleración por Hardware Directa */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}
</style>